import { render } from "./healhReportHistory.vue?vue&type=template&id=710edcf7&scoped=true&ts=true"
import script from "./healhReportHistory.vue?vue&type=script&lang=ts"
export * from "./healhReportHistory.vue?vue&type=script&lang=ts"

import "./healhReportHistory.vue?vue&type=style&index=0&id=710edcf7&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710edcf7"]])

export default __exports__